import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		// Indented under the Yes option's label, as in Figma.
		fields: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(2),
			marginLeft: theme.spacing(5),
			maxWidth: 380,
		},
		// The wizard's version (Figma 1645:33819): the note spans the modal, the fields are 340 wide.
		describedFields: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(2),
			marginLeft: theme.spacing(5),
		},
		describedField: {
			maxWidth: 340,
		},
		// 24px to the number field, where the rest of the fields sit 16 apart.
		describedType: {
			marginBottom: theme.spacing(1),
		},
		withHelper: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(1),
		},
		// On the Texting page the note spans the section; only the fields are capped.
		pageYes: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(2),
		},
		pageNote: {
			marginLeft: theme.spacing(5),
		},
		note: {
			fontSize: 16,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		label: {
			fontSize: 14,
			lineHeight: "20px",
			color: theme.palette.custom.textSecondary,
			marginBottom: theme.spacing(1),
		},
		describedLabel: {
			marginBottom: theme.spacing(2),
		},
		asterisk: {
			color: theme.palette.error.main,
		},
		plainTitle: {
			fontWeight: 400,
		},
		typeOption: {
			marginBottom: theme.spacing(2),
		},
		compactOption: {
			marginBottom: theme.spacing(1.5),
		},
		// Figma's Radio Option: options 16 apart, the description 4 under its label.
		describedOption: {
			marginBottom: theme.spacing(2),
		},
		describedDescription: {
			marginTop: theme.spacing(0.5),
		},
		describedAfter: {
			marginTop: 0,
		},
	} satisfies Record<string, CSSObject>);
};
